import { returnErrors } from './errorAction';
import { getApiCall, handle403Logout, postApiCall } from '../../utils/request';
import { GET_TESTS_DETAILS, TEST_REGISTER, VALIDATE_TOKEN, VALIDATE_CODE, UPLOAD_IMAGE, INTITATE_TEST, TEST_DETAILS, GET_QUESTION, GET_QUESTION_DETAIL, SUBMIT_ANSWER, SUBMIT_FEEDBACK, TEST_STATUS_UPDATE, RUN_CODE, SUBMIT_CODE, GET_STARTER_CODE, PROCTORING_EVENT, RUN_DATABASE_CODE, SUBMIT_DATABASE_CODE, VERIFY_CODE, GET_NOTEBOOK_URL, SUBMIT_NOTEBOOK, SUBMIT_TYPING_RESULT } from '../Types/types';
import axios from 'axios';

export const getTests = (id) => async (dispatch) => {
    try {
        const response = await getApiCall(`test/get-test?TestId=${id}`);
        if (response.status === 200) {
            dispatch({ type: GET_TESTS_DETAILS, payload: response.data.test })
        } else {

        }
    }
    catch (error) {
        handle403Logout(error);
        returnErrors(dispatch, error.response?.data?.responseMessages[0]?.message, error?.response?.status);
    }
}

export const testRegister = (obj) => async (dispatch) => {
    try {
        const response = await postApiCall(`candidate/test-registration`, obj);
        if (response.status === 200) {
            returnErrors(dispatch, 'Invitation sent succesfully.Please check your email', response?.status);
            return dispatch({ type: TEST_REGISTER, payload: response.data })
        } else {

        }
    }
    catch (error) {
        handle403Logout(error);
        returnErrors(dispatch, error.response?.data?.responseMessages[0]?.message, error?.response?.status);
    }
}

export const validateToken = (token) => async (dispatch) => {
    try {
        const response = await getApiCall(`test/validate-test-token?token=${token}`);
        if (response.status === 200) {
            sessionStorage.setItem('token', response.data.token);
            return dispatch({ type: VALIDATE_TOKEN, payload: response.data })
        }
        else {
            returnErrors(dispatch, response?.data?.responseMessages[0]?.message, response?.status);
        }
    }
    catch (error) {
        handle403Logout(error);
        returnErrors(dispatch, error.response?.data?.responseMessages[0]?.message, error?.response?.status);
        return dispatch({ type: 'LINK_EXPIRE', })
    }
}

export const validateCode = (token, code, name, authToken) => async (dispatch) => {
    try {
        axios.defaults.headers.common['Authorization'] = `Bearer ${authToken}`;
        const response = await axios.get(process.env.REACT_APP_API_KEY + `test/verify-test-code?token=${token}&code=${code}&name=${name}`);
        if (response.status === 200) {
            return dispatch({ type: VALIDATE_CODE, payload: response.data })
        }
        else {
            returnErrors(dispatch, 'Something went wrong', response?.status);
        }
    }
    catch (error) {
        handle403Logout(error);
        returnErrors(dispatch, error.response?.data?.responseMessages[0]?.message, error?.response?.status);
    }
}

export const uploadImage = (obj, testImageType, authToken) => async (dispatch) => {
    try {
        axios.defaults.headers.common['Authorization'] = `Bearer ${authToken}`;
        const response = await axios.post(process.env.REACT_APP_API_KEY + `test/add-test-images?testImageType=${testImageType}`, obj);
        if (response.status === 200) {
            return dispatch({ type: UPLOAD_IMAGE, payload: response.data })
        } else {
            returnErrors(dispatch, 'Something went wrong', response?.status);
        }
    }
    catch (error) {
        handle403Logout(error);
        returnErrors(dispatch, error.response?.data?.responseMessages[0]?.message, error?.response?.status);
    }
}



export const intiateTest = (token, authToken) => async (dispatch) => {
    const obj = {
        token
    }
    axios.defaults.headers.common['Authorization'] = `Bearer ${authToken}`;
    try {
        const response = await axios.post(process.env.REACT_APP_API_KEY + `test/start-test`, obj);
        if (response.status === 200) {
            return dispatch({ type: INTITATE_TEST, payload: response.data })
        } else {
            returnErrors(dispatch, 'Something went wrong', response?.status);
        }
    }
    catch (error) {
        handle403Logout(error);
        returnErrors(dispatch, error.response?.data?.responseMessages[0]?.message, error?.response?.status);
        if (!error.response) return undefined; // network error — let caller retry
        return dispatch({ type: 'Test_Credit', payload: error.response?.data?.responseMessages[0]?.message })
    }
}



export const getTestSummary = (testId, authToken) => async (dispatch) => {
    axios.defaults.headers.common['Authorization'] = `Bearer ${authToken}`;
    try {
        const response = await axios.get(process.env.REACT_APP_API_KEY + `test/get-candidate-test-details?CandidateTestId=${testId}`);
        if (response.status === 200) {
            dispatch({ type: TEST_DETAILS, payload: response.data.test })
            return dispatch({ type: TEST_DETAILS, payload: response.data.test })
        } else {
            returnErrors(dispatch, 'Something went wrong', response?.status);
        }
    }
    catch (error) {
        handle403Logout(error);
        returnErrors(dispatch, error.response?.data?.responseMessages[0]?.message, error?.response?.status);
    }
}


export const getQuestionDetail = (token, candidateTestQuestionId, authToken, countInfo) => async (dispatch) => {
    try {
        axios.defaults.headers.common['Authorization'] = `Bearer ${authToken}`;
        const response = await axios.get(
            process.env.REACT_APP_API_KEY +
            `candidate/get-candidate-test-question-detail?Token=${token}&CandidateTestQuestionId=${candidateTestQuestionId}`
        );
        if (response?.status === 200) {
            const question = response.data?.question || response.data;
            return dispatch({
                type: GET_QUESTION_DETAIL,
                payload: {
                    question: {
                        ...question,
                        // The question-detail response already carries its own correct
                        // currentQuestion/totalQuestion. countInfo (e.g. the test-summary
                        // API's currentQuestionIndex) is only a fallback for callers where
                        // the raw response doesn't include them — it must never clobber
                        // valid values already on the question, or the resumed question's
                        // displayed count regresses (e.g. MCQ resume showing "1/N").
                        ...(countInfo ? {
                            currentQuestion: question.currentQuestion ?? countInfo.currentQuestion,
                            totalQuestion: question.totalQuestion ?? countInfo.totalQuestion,
                        } : {}),
                    },
                    isTestCompleted: false,
                    isNextTest: false,
                }
            });
        } else {
            returnErrors(dispatch, 'Something went wrong', response?.status);
        }
    } catch (error) {
        handle403Logout(error);
        returnErrors(dispatch, 'Something went wrong', error?.response?.status);
    }
};

export const getQuestion = (token, authToken) => async (dispatch) => {
    try {
        axios.defaults.headers.common['Authorization'] = `Bearer ${authToken}`;

        const response = await axios.get(process.env.REACT_APP_API_KEY + `candidate/get-candidate-test-question?Token=${token}`);
        if (response?.status === 200) {
            return dispatch({ type: GET_QUESTION, payload: response.data })
        } else {
            returnErrors(dispatch, 'Something went wrong', response?.status);
        }
    }
    catch (error) {
        handle403Logout(error);
        returnErrors(dispatch, 'Something went wrong', error?.response?.status);
    }
}


export const submitAnswer = (obj, authToken) => async (dispatch) => {
    try {
        axios.defaults.headers.common['Authorization'] = `Bearer ${authToken}`;
        const response = await axios.post(process.env.REACT_APP_API_KEY + `test/submit-candidate-test-answer`, obj);
        if (response.status === 200) {
            return dispatch({ type: SUBMIT_ANSWER, payload: response.data })
        } else {
            returnErrors(dispatch, 'Something went wrong', response?.status);
        }
    }
    catch (error) {
        handle403Logout(error);
        returnErrors(dispatch, 'Something went wrong', error?.response?.status);
    }
}

export const feedbackSubmited = (obj, authToken) => async (dispatch) => {
    try {
        axios.defaults.headers.common['Authorization'] = `Bearer ${authToken}`;
        const response = await axios.post(process.env.REACT_APP_API_KEY + `test/add-test-feedback`, obj);
        if (response.status === 200) {
            return dispatch({ type: SUBMIT_FEEDBACK })
        } else {
            returnErrors(dispatch, 'Something went wrong', response?.status);
        }
    }
    catch (error) {
        handle403Logout(error);
        returnErrors(dispatch, 'Something went wrong', error?.response?.status);
    }
}

export const updateTestStatus = (obj, authToken) => async (dispatch) => {
    axios.defaults.headers.common['Authorization'] = `Bearer ${authToken}`;
    try {
        const response = await axios.post(process.env.REACT_APP_API_KEY + `candidate/update-test-status`, obj);
        if (response.status === 200) {
            return dispatch({ type: TEST_STATUS_UPDATE, payload: response.data })
        } else {
            returnErrors(dispatch, 'Something went wrong', response?.status);
        }
    }
    catch (error) {
        handle403Logout(error);
        returnErrors(dispatch, error.response?.data?.responseMessages[0]?.message, error?.response?.status);
    }
}

export const getStarterCode = (token, TestId, testQuestionId, lang, authToken) => async (dispatch) => {
    axios.defaults.headers.common['Authorization'] = `Bearer ${authToken}`;
    try {
        const response = await axios.get(process.env.REACT_APP_API_KEY + `codingquestion/starter-code?Token=${token}&CandidateTestId=${TestId}&CandidateTestQuestionId=${testQuestionId}&Language=${lang}`);
        if (response.status === 200) {
            return dispatch({ type: GET_STARTER_CODE, payload: response.data })
        } else {
            returnErrors(dispatch, 'Something went wrong', response?.status);
        }
    }
    catch (error) {
        handle403Logout(error);
        returnErrors(dispatch, error.response?.data?.responseMessages[0]?.message, error?.response?.status);
    }
}

export const verifyCode = (obj, authToken) => async (dispatch) => {
    axios.defaults.headers.common['Authorization'] = `Bearer ${authToken}`;
    try {
        const response = await axios.post(process.env.REACT_APP_API_KEY + `candidate/verify-code`, obj);
        console.log(response.data)
        if (response.status === 200) {
            return dispatch({ type: VERIFY_CODE, payload: response.data.testCases })
        } else {
            returnErrors(dispatch, 'Something went wrong', response?.status);
        }
    }
    catch (error) {
        handle403Logout(error);
        returnErrors(dispatch, error.response?.data?.responseMessages[0]?.message, error?.response?.status);
    }
}


export const compileCode = (obj, authToken) => async (dispatch) => {
    axios.defaults.headers.common['Authorization'] = `Bearer ${authToken}`;
    dispatch({ type: RUN_CODE, payload: null });
    try {
        const response = await axios.post(process.env.REACT_APP_API_KEY + `candidate/run-code`, obj);
        console.log(response.data)
        if (response.status === 200) {
            return dispatch({ type: RUN_CODE, payload: response.data })
        } else {
            returnErrors(dispatch, 'Something went wrong', response?.status);
        }
    }
    catch (error) {
        handle403Logout(error);
        returnErrors(dispatch, error.response?.data?.responseMessages[0]?.message, error?.response?.status);
    }
}

export const submitCode = (obj, authToken) => async (dispatch) => {
    axios.defaults.headers.common['Authorization'] = `Bearer ${authToken}`;
    try {
        const response = await axios.post(process.env.REACT_APP_API_KEY + `candidate/submit-code`, obj);
        if (response.status === 200) {
            return dispatch({ type: SUBMIT_CODE, payload: response.data })
        } else {
            returnErrors(dispatch, 'Something went wrong', response?.status);
        }
    }
    catch (error) {
        handle403Logout(error);
        returnErrors(dispatch, error.response?.data?.responseMessages[0]?.message, error?.response?.status);
    }
}

export const sendProctoringEvent = (obj, authToken) => async (dispatch, getState) => {
    try {
        const { candidateTest } = getState();

        // fallback if authToken not passed
        const token =
            authToken || candidateTest?.token || sessionStorage.getItem("token");

        if (!token) {
            console.warn("⚠️ Skipping Proctoring event: missing auth token");
            return null;
        }

        // ensure candidateTestId is always present
        const candidateTestId =
            obj.candidateTestId || candidateTest?.candidateDetails?.candidateTestId;

        if (!candidateTestId) {
            console.warn("⚠️ Skipping Proctoring event: missing candidateTestId");
            return null;
        }

        const payload = {
            candidateTestId,
            eventType: obj.eventType,
            duration: obj.duration,
            ...(obj.details !== undefined ? { details: obj.details } : {}),
        };

        axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
        const response = await axios.post(
            process.env.REACT_APP_API_KEY + `Proctoring/event`,
            payload
        );

        if (response.status === 200) {
            dispatch({ type: PROCTORING_EVENT, payload: response.data });
            return response.data;
        } else {
            returnErrors(dispatch, "Something went wrong", response?.status);
        }
    } catch (error) {
        console.error("❌ Proctoring event error:", error?.response || error);
        return null;
    }
};

export const runDatabaseCode = (obj, authToken) => async (dispatch) => {
    axios.defaults.headers.common['Authorization'] = `Bearer ${authToken}`;
    try {
        const response = await axios.post(process.env.REACT_APP_API_KEY + `databasequestion/run-code`, obj);
        if (response.status === 200) {
            return dispatch({ type: RUN_DATABASE_CODE, payload: response.data });
        } else {
            returnErrors(dispatch, 'Something went wrong', response?.status);
        }
    } catch (error) {
        handle403Logout(error);
        returnErrors(dispatch, error.response?.data?.responseMessages[0]?.message, error?.response?.status);
    }
};

export const submitDatabaseCode = (obj, authToken) => async (dispatch) => {
    axios.defaults.headers.common['Authorization'] = `Bearer ${authToken}`;
    try {
        const response = await axios.post(process.env.REACT_APP_API_KEY + `databasequestion/submit-code`, obj);
        if (response.status === 200) {
            return dispatch({ type: SUBMIT_DATABASE_CODE, payload: response.data });
        } else {
            returnErrors(dispatch, 'Something went wrong', response?.status);
        }
    } catch (error) {
        handle403Logout(error);
        returnErrors(dispatch, error.response?.data?.responseMessages[0]?.message, error?.response?.status);
    }
};

//get notebook url
export const getNotebookUrl = (token, candidateTestId, candidateTestQuestionId, authToken) => async (dispatch) => {
    axios.defaults.headers.common['Authorization'] = `Bearer ${authToken}`;
    try {
        const response = await axios.get(
            process.env.REACT_APP_API_KEY +
            `codingquestion/notebook-url?Token=${token}&CandidateTestId=${candidateTestId}&CandidateTestQuestionId=${candidateTestQuestionId}`
        );
        if (response.status === 200) {
            return dispatch({
                type: GET_NOTEBOOK_URL,
                payload: {
                    url: response.data.url,
                    candidateTestQuestionId
                }
            });
        } else {
            returnErrors(dispatch, 'Something went wrong', response?.status);
        }
    } catch (error) {
        handle403Logout(error);
        returnErrors(dispatch, error.response?.data?.responseMessages?.[0]?.message, error?.response?.status);
    }
};

//Submit Notebook test
// Idempotency guard: a notebook question can be submitted from two independent
// paths (the manual "SUBMIT NOTEBOOK" button in Main, and the timer-expiry
// auto-submit in onTimesUp). This module-level set makes any duplicate dispatch
// for the same candidateTestQuestionId a no-op — entries stay once a submit has
// started and are only cleared if the request fails, so a retry is still possible.
const notebookSubmitGuard = new Set();

export const submitNotebook = (obj, authToken) => async (dispatch) => {
    const guardKey = obj?.candidateTestQuestionId;
    if (guardKey != null) {
        if (notebookSubmitGuard.has(guardKey)) return;
        notebookSubmitGuard.add(guardKey);
    }

    axios.defaults.headers.common['Authorization'] = `Bearer ${authToken}`;

    try {
        const response = await axios.post(process.env.REACT_APP_API_KEY + `candidate/submit-notebook`, obj);
        if (response.status === 200) {
            return dispatch({ type: SUBMIT_NOTEBOOK, payload: { ...response.data, candidateTestQuestionId: obj.candidateTestQuestionId } });
        } else {
            if (guardKey != null) notebookSubmitGuard.delete(guardKey);
            returnErrors(dispatch, 'Something went wrong', response?.status);
        }
    } catch (error) {
        if (guardKey != null) notebookSubmitGuard.delete(guardKey);
        handle403Logout(error);
        returnErrors(dispatch, error.response?.data?.responseMessages?.[0]?.message, error?.response?.status);
    }
};

export const uploadCandidateTestFile = (file, authToken) => async (dispatch) => {
    const formData = new FormData();
    formData.append("file", file);

    try {
        axios.defaults.headers.common['Authorization'] = `Bearer ${authToken}`;
        const response = await axios.post(process.env.REACT_APP_API_KEY + `storage/create`, formData, { headers: { "Content-Type": "multipart/form-data" } });
        return response.data;
    } catch (error) {
        returnErrors(dispatch, error.response?.data?.responseMessages?.[0]?.message, error?.response?.status);
    }
};

export const startAdditionalDurationTimer = (token, authToken) => async (dispatch) => {
    axios.defaults.headers.common['Authorization'] = `Bearer ${authToken}`;
    try {
        const response = await axios.post(process.env.REACT_APP_API_KEY + `candidate/start-additional-duration-timer`, { token });
        if (response.status === 200) {
            return dispatch({ type: 'START_ADDITIONAL_DURATION_TIMER', payload: response.data });
        } else {
            returnErrors(dispatch, 'Something went wrong', response?.status);
        }
    } catch (error) {
        handle403Logout(error);
        returnErrors(dispatch, error.response?.data?.responseMessages?.[0]?.message, error?.response?.status);
    }
};

export const pauseAdditionalDurationTimer = (token, authToken) => async (dispatch) => {
    axios.defaults.headers.common['Authorization'] = `Bearer ${authToken}`;
    try {
        const response = await axios.post(process.env.REACT_APP_API_KEY + `candidate/pause-additional-duration-timer`, { token });
        if (response.status === 200) {
            return dispatch({ type: 'PAUSE_ADDITIONAL_DURATION_TIMER', payload: response.data });
        } else {
            returnErrors(dispatch, 'Something went wrong', response?.status);
        }
    } catch (error) {
        handle403Logout(error);
        returnErrors(dispatch, error.response?.data?.responseMessages?.[0]?.message, error?.response?.status);
    }
};

export const heartbeatAdditionalDuration = (token, authToken) => async (dispatch) => {
    axios.defaults.headers.common['Authorization'] = `Bearer ${authToken}`;
    try {
        const response = await axios.post(process.env.REACT_APP_API_KEY + `candidate/heartbeat-additional-duration`, { token });
        if (response.status === 200) {
            return dispatch({ type: 'HEARTBEAT_ADDITIONAL_DURATION', payload: response.data });
        } else {
            returnErrors(dispatch, 'Something went wrong', response?.status);
        }
    } catch (error) {
        // Heartbeat might fail silently without throwing user errors
        console.error("Heartbeat error", error);
    }
};

export const reportIssue = (obj, authToken) => async (dispatch) => {
    axios.defaults.headers.common['Authorization'] = `Bearer ${authToken}`;
    try {
        const response = await axios.post(process.env.REACT_APP_API_KEY + `assessmentissue/issues`, obj);
        if (response.status === 200) {
            return dispatch({ type: 'REPORT_ISSUE', payload: response.data });
        } else {
            returnErrors(dispatch, 'Something went wrong', response?.status);
        }
    } catch (error) {
        handle403Logout(error);
        returnErrors(dispatch, error.response?.data?.responseMessages?.[0]?.message, error?.response?.status);
    }
};

export const heartbeatAssessmentActivity = (token, authToken) => async (dispatch) => {
    axios.defaults.headers.common['Authorization'] = `Bearer ${authToken}`;
    try {
        const response = await axios.post(process.env.REACT_APP_API_KEY + `candidate/heartbeat-assessment-activity`, { token });
        if (response.status === 200) {
            return dispatch({ type: 'HEARTBEAT_ASSESSMENT_ACTIVITY', payload: response.data });
        }
    } catch (error) {
        console.error("Assessment heartbeat error", error);
    }
};

//submit typing test result
export const submitTypingResult = (testId, questionId, payload) => async (dispatch, getState) => {
    try {
        const { candidateTest } = getState();
        const authToken = candidateTest?.token || sessionStorage.getItem('token');
        const invitationToken = candidateTest?.candidateDetails?.invitationToken || sessionStorage.getItem('CANDIDATE_INVITATION_TOKEN');
        axios.defaults.headers.common['Authorization'] = `Bearer ${authToken}`;
        const response = await axios.post(process.env.REACT_APP_API_KEY + `candidate/submit-typing`, {
            token: invitationToken,
            candidateTestId: testId,
            candidateTestQuestionId: questionId,
            ...payload,
        });
        if (response.status === 200) {
            return dispatch({ type: SUBMIT_TYPING_RESULT, payload: response.data });
        } else {
            returnErrors(dispatch, 'Something went wrong', response?.status);
        }
    } catch (error) {
        handle403Logout(error);
        returnErrors(dispatch, error.response?.data?.responseMessages?.[0]?.message, error?.response?.status);
    }
};

export const getViolationSummary = (token, candidateTestId, authToken) => async (dispatch) => {
    axios.defaults.headers.common['Authorization'] = `Bearer ${authToken}`;
    try {
        const response = await axios.get(
            process.env.REACT_APP_API_KEY + `proctoring/violation-summary?Token=${token}&CandidateTestId=${candidateTestId}`
        );
        if (response.status === 200) {
            return dispatch({ type: 'GET_VIOLATION_SUMMARY', payload: response.data });
        } else {
            returnErrors(dispatch, 'Something went wrong', response?.status);
        }
    } catch (error) {
        handle403Logout(error);
        returnErrors(dispatch, error.response?.data?.responseMessages?.[0]?.message, error?.response?.status);
    }
};